import styled, {css} from 'styled-components';

export const Tr = styled.tr`
  &:hover {
  cursor: ${props => props.clickable? 'pointer' : 'initial'};
    background-color: ${props => props.theme['table_line-hover']} !important;
  }
`;

export const Th = styled.th`
  text-transform: ${props => props.uppercase? 'uppercase' : 'initial'};
  width: ${props => props.width || 'auto'};
  min-width: ${props => props.minWidth || 'auto'};
  max-width: ${props => props.maxWidth || 'auto'};
  text-align: ${props => props.textAlign? props.textAlign : 'left'};
  padding: .85rem 1.1rem !important;
  padding-left: ${props => props.paddingLeft || '1.1rem'};
  border-bottom: 0 !important;
  color: #152b4e;
  font-size: .8rem;
  font-weight: 600;
  letter-spacing: .02em;
  vertical-align: middle;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  
`;

export const Td = styled.td`
  text-transform: ${props => props.uppercase? 'uppercase' : 'initial'};
  padding: .78rem 1.1rem !important;
  width: ${props => props.width || 'auto'};
  border-right: ${props => props.theme[props.bordercolor || 'color_white']} solid .1rem;
  border-top: 0;
  vertical-align: ${props => props.align? `${props.align} !important` : 'middle'};
  min-height: 52px;
  min-width: ${props => props.minWidth || 'auto'};
  max-width: ${props => props.maxWidth || 'auto'};
  text-align: ${props => props.textAlign? props.textAlign : 'left'};
  color: #3d4f63;
  font-size: .8125rem;
  font-weight: 400;
  letter-spacing: .02em;
  border-bottom: 1px solid #ececec;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  ${props => css`${props.customStyle}`};
`;

export const BorderedButton = styled.button`
  width: 5rem;
  background-color: transparent;
  font-size: .69rem;
  font-weight: 600;
  line-height: 1.5;
  text-transform: capitalize;
  padding: 0 .1rem;
  height: 24px;
  border-radius: 10px;
  border: 1px solid ${props => props.color? props.theme[props.color] : props.theme.color_purple};
  color: ${props => props.color? props.theme[props.color] : props.theme.color_purple};
  transform: scale(1);
  transition: all 120ms ease-in;
  cursor: pointer;

  @media(max-width: 800px){
    width: 5.3rem;
  }

&:hover {
    background-color: ${props => props.color? props.theme[props.color] : props.theme.color_purple};
    color: ${props => props.theme.color_white};
    transform: none;
  }
`;

export const UnborderedButton = styled.button`
  width: 5rem;
  background-color: transparent;
  font-size: .74rem;
  font-weight: 600;
  line-height: 1.5;
  text-transform: capitalize;
  padding: 0 .5rem;
  height: 24px;
  border-radius: 10px;
  border: none;
  color: ${props => props.color? props.theme[props.color] : props.theme.color_purple};
  transform: scale(1);
  transition: all 120ms ease-in;
  cursor: pointer;

/* &:hover {
    background-color: ${props => props.color? props.theme[props.color] : props.theme.color_purple};
    color: ${props => props.theme.color_white};
    transform: scale(1.1);
    font-weight: normal;
  } */
`;

export const BalanceTh = styled(Th)`
  width: 7.3vw !important;
`;

export const CreditTh = styled(Th)`
  width: 10vw !important;
`;

export const EditCreditTh = styled(Th)`
  width: 4vw !important;
`;


